module.exports = __webpack_public_path__ + "static/media/shiksha ka suraj.34fbafd8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/shiksha ka suraj.gif
// module id = 366
// module chunks = 0